import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import authService from "../services/authService";
import Header from "../components/ui/Header";

const SignUpPage = () => {
  const [formData, setFormData] = useState({
    email: "",
    username: "",
    password: "",
  });
  
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    let tempErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email)) {
      tempErrors.email = "Please enter a valid email address.";
    }

    if (formData.username.trim().length < 3) {
      tempErrors.username = "Username must be at least 3 characters.";
    }

 
    if (formData.password.length < 8) {
      tempErrors.password = "Password must be at least 8 characters long.";
    }


    if (Object.keys(tempErrors).length > 0) {
      setErrors(tempErrors);
      return; 
    }

    
    try {
      const { response, data } = await authService.register(formData);
      
      if (!response.ok) {
        
        throw new Error(data.error || "Registration failed.");
      }
      
      
      navigate("/login");
    } catch (error) {
     
      setErrors({ server: error.message });
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F7FAFC] text-[#0F172A] font-[Manrope]">
      {/* HEADER */}
      <Header />

      {/* MAIN SIGN-UP CARD */}
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-2xl shadow-sm p-10">
          <h2 className="text-3xl font-extrabold text-[#0F172A] text-center mb-8">
            Create your DEE­Bug account
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Server-wide Error (e.g., "Username Taken") */}
            {errors.server && (
              <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-2 rounded-md text-sm font-bold text-center">
                {errors.server}
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-base font-medium text-[#0F172A] mb-2">Email</label>
              <input
                type="text" // Changed to text so we can control validation messages
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 transition ${
                  errors.email ? "border-red-500 focus:ring-red-200" : "border-[#E2E8F0] focus:ring-[#0EA5E9]/80"
                }`}
              />
              {errors.email && <p className="text-red-500 text-xs mt-1 font-bold">{errors.email}</p>}
            </div>

            <div>
              <label htmlFor="username" className="block text-base font-medium text-[#0F172A] mb-2">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 transition ${
                  errors.server?.includes("Username") ? "border-red-500 focus:ring-red-200" : "border-[#E2E8F0] focus:ring-[#0EA5E9]/80"
                }`}
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-base font-medium text-[#0F172A] mb-2">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 transition ${
                  errors.password ? "border-red-500 focus:ring-red-200" : "border-[#E2E8F0] focus:ring-[#0EA5E9]/80"
                }`}
              />
              {errors.password && <p className="text-red-500 text-xs mt-1 font-bold">{errors.password}</p>}
            </div>

            <button type="submit" className="w-full bg-[#0EA5E9] text-white py-2.5 rounded-md font-semibold hover:bg-[#0284C7] transition">
              Sign Up
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-[#334155]">
              Already have an account?{" "}
              <button
                onClick={() => navigate("/login")}
                className="text-[#0EA5E9] font-medium hover:underline"
              >
                Log In
              </button>
            </p>
          </div>
        </div>
      </main>

      {/* FOOTER (UPDATED) */}
      <footer className="bg-[#F1F5F9] border-t border-[#E2E8F0] py-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between px-6 gap-4 text-[#475569] text-base">
          <p className="font-medium">
            © {currentYear} DEE­Bug™. All rights reserved.
          </p>

          <div className="flex flex-wrap justify-center gap-8">
            <Link to="/privacy" className="hover:text-[#0EA5E9] transition font-medium">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-[#0EA5E9] transition font-medium">
              Terms
            </Link>
            <Link to="/security" className="hover:text-[#0EA5E9] transition font-medium">
              Security
            </Link>
            <Link to="/contact" className="hover:text-[#0EA5E9] transition font-medium">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SignUpPage;
